export default __webpack_public_path__ + "static/media/formik.95443f3a.png";